import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { adminMainUrl } from '../../../../../Config';
import { toast } from 'react-toastify';
import Select from 'react-select'
import { customStyles } from '../../../../../HelperFunctions';
import TextAreaJSX from './TextAreaJSX';
import InputTextJSX from './InputTextJSX';
import InputDateJSX from './InputDateJSX';
import SelectReactJSX from './SelectReactJSX';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from "js-cookie";
import { calculateTotalFreightMAWB, getFFAirImpAirport, getFFAirImpConsigneeBranch, getFFAirImpConsigneeBranchBank, getFFAirImpCurrency, getFFAirImpFinalQuotation, getFFAirImpJobOrder, getFFAirImpOrganisation, getFFAirImpOrganisationBranch, getFFAirImportMAWBDetail, getFFAirImpShipperBranch, getFFAirImpShipperBranchBank, getFFAirImpUnusedHAWBList, getFFAirImpUnusedHAWBUpdateList } from '../../../../../Redux/action/FreightForwarding/Console/FFAirImpAction';
import { useNavigate, useParams } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Beatloader from '../../../../../Common/Loaders/Beatloader';
import { getMasterIATAAgent } from '../../../../../Redux/action/MasterAction';

const ConsoleShipmentMAWBEditAI = ({ title }) => {
    const { b64id } = useParams();
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [showLoader, setShowLoader] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');

    useEffect(() => {
        if (token && user_id) {
            dispatch(getFFAirImpJobOrder(token, user_id));
            dispatch(getFFAirImpFinalQuotation(token, user_id));
            dispatch(getFFAirImpCurrency(token, user_id));
            dispatch(getFFAirImpAirport(token, user_id));
            dispatch(getFFAirImpOrganisation(token, user_id));
            dispatch(getMasterIATAAgent(token, user_id));

            if (b64id) {
                let mawb_id = atob(b64id);
                if (mawb_id) {
                    dispatch(getFFAirImpUnusedHAWBUpdateList(token, user_id, mawb_id));
                    dispatch(getFFAirImportMAWBDetail(token, user_id, mawb_id))
                }
            } else {
                toast.error("Please enter correct URL.");
                navigate(-1);
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }

    }, [token, user_id]);

    const [modalShow, setModalShow] = React.useState(false);

    const {

        loadingFFAirImpMAWBDetail,
        FFAirImpMAWBDetail,
        FFAirImpMAWBDetailError,

        loadingFFAirImpJobOrderList,
        FFAirImpJobOrderListError,
        FFAirImpJobOrderList,

        loadingFFAirImpFinalQuotationList,
        FFAirImpFinalQuotationListError,
        FFAirImpFinalQuotationList,

        loadingFFAirImpCurrencyList,
        FFAirImpCurrencyListError,
        FFAirImpCurrencyList,

        loadingFFAirImpAirportList,
        FFAirImpAirportListError,
        FFAirImpAirportList,

        //organisation list
        loadingFFAirImpOrganisationList,
        FFAirImpOrganisationList,
        FFAirImpOrganisationListError,


        //organisation shipper branch list
        loadingFFAirImpShipperBranchList,
        FFAirImpShipperBranchList,
        FFAirImpShipperBranchListError,

        //organisation consignee branch list
        loadingFFAirImpConsigneeBranchList,
        FFAirImpConsigneeBranchList,
        FFAirImpConsigneeBranchListError,

        //organisatoin shipper branch bank list
        loadingFFAirImpShipperBranchBankList,
        FFAirImpShipperBranchBankList,
        FFAirImpShipperBranchBankListError,

        //organisatoin consignee branch bank list
        loadingFFAirImpConsigneeBranchBankList,
        FFAirImpConsigneeBranchBankList,
        FFAirImpConsigneeBranchBankListError,

        //unused hawb list update
        loadingFFAirImpUnusedHAWBUpdateList,
        FFAirImpUnusedHAWBUpdateList,
        FFAirImpUnusedHAWBListEUpdaterror,

        //mawb -> calculate total freight hawb
        loadingFFAirImpTotalFreight,
        FFAirImpTotalFreight,
        FFAirImpTotalFreightError,
    } = useSelector(state => state.FFAirImpReducer);


    const {
        loadingMasterIATAAgent,
        MasterIATAAgent,
        MasterIATAAgentError

    } = useSelector(state => state?.MasterReducer);


    const [iataAgentOptions, setIATAAgentOptions] = useState([]);
    useEffect(() => {
        if (MasterIATAAgent) {
            let arr = [];
            MasterIATAAgent.map(v => { arr.push({ value: v.id, label: `${v.name} - ${v.iata_code}` }) });
            setIATAAgentOptions(arr);
        } else {
            setIATAAgentOptions([]);
        }
    }, [MasterIATAAgent])


    const [jobOrderOptions, setJobOrderOptions] = useState([]);
    useEffect(() => {
        if (FFAirImpJobOrderList) {
            let arr = [];
            FFAirImpJobOrderList.map(val => arr.push({ value: val.id, label: val.job_order_unique_no, quotation_id: Number(val.quotation_id) }));
            setJobOrderOptions(arr);
        }
    }, [loadingFFAirImpJobOrderList, FFAirImpJobOrderList]);

    const [unusedHAWBOptions, setUnusedHAWBptions] = useState([]);
    useEffect(() => {
        if (FFAirImpUnusedHAWBUpdateList) {
            let arr = [];
            FFAirImpUnusedHAWBUpdateList.map(val => arr.push({ value: val.id, label: val.hawb_number }));
            setUnusedHAWBptions(arr);
        }
    }, [loadingFFAirImpUnusedHAWBUpdateList, FFAirImpUnusedHAWBUpdateList]);

    const [organisationOptions, setOrganisationOptions] = useState([]);
    useEffect(() => {
        if (FFAirImpOrganisationList) {
            let arr = [];
            FFAirImpOrganisationList.map(val => arr.push({ value: val.id, label: `${val.name} (${val.customerType})`, entity: val.entity_type ? JSON.parse(val.entity_type) : [] }));
            setOrganisationOptions(arr);
        }
    }, [FFAirImpOrganisationList]);

    const [finalQuotationOptions, setFinalQuotationOptions] = useState([]);
    useEffect(() => {
        if (FFAirImpFinalQuotationList) {
            let arr = [];
            FFAirImpFinalQuotationList.map(val => arr.push({ value: val.id, label: val.ship_quotation_no }));
            setFinalQuotationOptions(arr);
        }
    }, [loadingFFAirImpFinalQuotationList, FFAirImpFinalQuotationList]);

    const [currencyOptions, setCurrencyOptions] = useState([]);
    useEffect(() => {
        if (FFAirImpCurrencyList) {
            let arr = [];
            FFAirImpCurrencyList.map(val => arr.push({ value: val.id, label: `${val.currency} (${val.currency_symbol})` }));
            setCurrencyOptions(arr);
        }
    }, [loadingFFAirImpCurrencyList, FFAirImpCurrencyList]);

    const [airportOptions, setAirportOptions] = useState([]);
    useEffect(() => {
        if (FFAirImpAirportList) {
            let arr = [];
            FFAirImpAirportList.map(val => arr.push({ value: val.id, label: `${val.name} (${val.code}) - ${val.country_name}` }));
            setAirportOptions(arr);
        }
    }, [loadingFFAirImpAirportList, FFAirImpAirportList]);


    let [shipperOrganisationOptions, setShipperOrganisationOptions] = useState([]);
    let [consigneeOrganisationOptions, setConsigneeOrganisationOptions] = useState([]);

    let [shipperBranchOptions, setShipperBranchOptions] = useState([]);
    let [consigneeBranchOptions, setConsigneeBranchOptions] = useState([]);

    let [shipperBankOptions, setShipperBankOptions] = useState([]);
    let [consigneeBankOptions, setConsigneeBankOptions] = useState([]);


    useEffect(() => {
        if (organisationOptions) {
            let shipperArr = [];
            let consigneeArr = [];

            organisationOptions.map(object => {
                if (object.entity && object.entity.includes("shipper")) {
                    shipperArr.push(object);
                }
                if (object.entity && object.entity.includes("consignee")) {
                    consigneeArr.push(object);
                }
            });
            setShipperOrganisationOptions(shipperArr);
            setConsigneeOrganisationOptions(consigneeArr);
        }
    }, [organisationOptions]);


    const handleShipperBranch = (shipper_id) => {
        if (shipper_id && token && user_id) {
            dispatch(getFFAirImpShipperBranch(token, user_id, shipper_id));
        }
    };
    const handleShipperBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFAirImpShipperBranchBank(token, user_id, branch_id));
        }
    };

    const handleConsigneeBranch = (consignee_id) => {
        if (consignee_id && token && user_id) {
            dispatch(getFFAirImpConsigneeBranch(token, user_id, consignee_id));
        }
    };
    const handleConsigneeBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFAirImpConsigneeBranchBank(token, user_id, branch_id));
        }
    };


    useEffect(() => {
        // console.log(FFAirImpShipperBranchList);
        if (FFAirImpShipperBranchList) {
            let arr = [];
            FFAirImpShipperBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setShipperBranchOptions(arr);
        }
    }, [FFAirImpShipperBranchList]);

    useEffect(() => {
        if (FFAirImpShipperBranchBankList) {
            let arr = [];
            FFAirImpShipperBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setShipperBankOptions(arr);
        }
    }, [FFAirImpShipperBranchBankList]);

    useEffect(() => {
        if (FFAirImpConsigneeBranchList) {
            let arr = [];
            FFAirImpConsigneeBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setConsigneeBranchOptions(arr);
        }
    }, [FFAirImpConsigneeBranchList]);

    useEffect(() => {
        if (FFAirImpConsigneeBranchBankList) {
            let arr = [];
            FFAirImpConsigneeBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setConsigneeBankOptions(arr);
        }
    }, [FFAirImpConsigneeBranchBankList]);


    const initialValues = {
        shipper_id: "",
        shipper_branch_id: "",
        shipper_branch_bank_account_id: "",
        consignee_id: "",
        consignee_branch_id: "",
        consignee_branch_bank_account_id: "",
        issuing_carrier_agent_id: "",
        // issuing_carrier_agent_name: "",
        // issuing_carrier_agent_address: "",
        // agent_iata_code: "",
        // agent_account_number: "",
        hawb_collection: [],
        handling_info: "",
        nature_and_qty: "",
        remarks: "",
        airwaybill_date: "",
        clearance_Exec_date: "",
        CSR_date: "",
        executed_at: "",
        airport_of_departure_id: "",
        airport_of_departure_name: "",
        airport_of_destination_id: "",
        airport_of_destination_name: "",
        to_one: "",
        by_first_carrier: "",
        to_two: "",
        by_one: "",
        to_three: "",
        by_two: "",
        flight_no_one: "",
        flight_date_one: "",
        flight_no_two: "",
        flight_date_two: "",
        cto: "",
        currency: "",
        chgs_code: "",
        wt_val: "",
        other: "",
        declared_value_for_carriage: "",
        declared_value_for_customs: "",
        amount_of_insurance: "",
        weight_charge_prepaid: "",
        weight_charge_collect: "",
        valuation_charge_prepaid: "",
        valuation_charge_collect: "",
        tax_prepaid: "",
        tax_collect: "",
        total_due_agent_prepaid: "",
        total_due_agent_collect: "",
        total_due_carrier_prepaid: "",
        total_due_carrier_collect: "",
        confirm_mawb_generate: ""
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            // let rateArr = [];
            // for (let i = 1; i <= 4; i++) {
            //     const obj = {
            //         no_of_pkg: values[`no_of_pkg${i}`],
            //         gross_wt: values[`gross_wt${i}`],
            //         kg_lb: values[`kg_lb${i}`],
            //         rate_class: values[`rate_class${i}`],
            //         comm_item_No: values[`comm_item_No${i}`],
            //         chargeable_wt: values[`chargeable_wt${i}`],
            //         rate_charge: values[`rate_charge${i}`],
            //         total_freight: values[`total_freight${i}`],
            //     };
            //     console.log(obj);
            //     const hasValue = Object.values(obj).some(value => value !== "");
            //     if (hasValue) {
            //         rateArr.push(obj);
            //     }
            // }
            // values.rate_description_json = rateArr;
            // console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                };
                let id = atob(b64id);
                if (id) {
                    values.id = id
                } else {
                    toast.error("Id not defined.");
                    return;
                }
                axios.post(`${adminMainUrl}/api/freight/forwarding/air/import/mawb/update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            resetForm();
                            //reset all the dropdowns
                            setShipperOrganisationOptions([]);
                            setConsigneeOrganisationOptions([]);
                            setShipperBranchOptions([]);
                            setConsigneeBranchOptions([]);
                            setShipperBankOptions([]);
                            setConsigneeBankOptions([]);
                            navigate(`/flexichain/job-order/freight-forwarding/shipment/air/import/console/mawb`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });


    useEffect(() => {
        if (loadingFFAirImpMAWBDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        // console.log(FFAirImpMAWBDetail);
        if (FFAirImpMAWBDetail) {
            formik.setFieldValue("shipper_id", FFAirImpMAWBDetail?.shipper_id);
            if (FFAirImpMAWBDetail?.shipper_id) {
                handleShipperBranch(FFAirImpMAWBDetail?.shipper_id);
            }
            formik.setFieldValue("shipper_branch_id", FFAirImpMAWBDetail?.shipper_branch_id);
            if (FFAirImpMAWBDetail?.shipper_branch_id) {
                handleShipperBanks(FFAirImpMAWBDetail?.shipper_branch_id);
            }
            formik.setFieldValue("shipper_branch_bank_account_id", FFAirImpMAWBDetail?.shipper_branch_bank_account_id);
            formik.setFieldValue("consignee_id", FFAirImpMAWBDetail?.consignee_id);
            if (FFAirImpMAWBDetail?.consignee_id) {
                handleConsigneeBranch(FFAirImpMAWBDetail?.consignee_id);
            }
            formik.setFieldValue("consignee_branch_id", FFAirImpMAWBDetail?.consignee_branch_id);
            if (FFAirImpMAWBDetail?.consignee_branch_id) {
                handleConsigneeBanks(FFAirImpMAWBDetail?.consignee_branch_id);
            }
            formik.setFieldValue("consignee_branch_bank_account_id", FFAirImpMAWBDetail?.consignee_branch_bank_account_id);
            formik.setFieldValue("issuing_carrier_agent_id", FFAirImpMAWBDetail?.issuing_carrier_agent_id);
            // formik.setFieldValue("issuing_carrier_agent_name", FFAirImpMAWBDetail?.issuing_carrier_agent_name);
            // formik.setFieldValue("issuing_carrier_agent_address", FFAirImpMAWBDetail?.issuing_carrier_agent_address);
            // formik.setFieldValue("agent_iata_code", FFAirImpMAWBDetail?.agent_iata_code);
            // formik.setFieldValue("agent_account_number", FFAirImpMAWBDetail?.agent_account_number);
            // formik.setFieldValue("hawb_collection", FFAirImpMAWBDetail?.hawb_collection);
            formik.setFieldValue("handling_info", FFAirImpMAWBDetail?.handling_info);
            formik.setFieldValue("nature_and_qty", FFAirImpMAWBDetail?.nature_and_qty);
            formik.setFieldValue("remarks", FFAirImpMAWBDetail?.remarks);
            formik.setFieldValue("airwaybill_date", FFAirImpMAWBDetail?.airwaybill_date);
            formik.setFieldValue("clearance_Exec_date", FFAirImpMAWBDetail?.clearance_Exec_date);
            formik.setFieldValue("CSR_date", FFAirImpMAWBDetail?.CSR_date);
            formik.setFieldValue("executed_at", FFAirImpMAWBDetail?.executed_at);

            formik.setFieldValue("airport_of_departure_id", FFAirImpMAWBDetail?.mawb_booking_routing ? FFAirImpMAWBDetail?.mawb_booking_routing?.airport_of_departure_id : "");
            formik.setFieldValue("airport_of_departure_name", FFAirImpMAWBDetail?.mawb_booking_routing ? FFAirImpMAWBDetail?.mawb_booking_routing?.airport_of_departure_name : "");
            formik.setFieldValue("airport_of_destination_id", FFAirImpMAWBDetail?.mawb_booking_routing ? FFAirImpMAWBDetail?.mawb_booking_routing?.airport_of_destination_id : "");
            formik.setFieldValue("airport_of_destination_name", FFAirImpMAWBDetail?.mawb_booking_routing ? FFAirImpMAWBDetail?.mawb_booking_routing?.airport_of_destination_name : "");

            formik.setFieldValue("to_one", FFAirImpMAWBDetail?.mawb_booking_routing ? FFAirImpMAWBDetail?.mawb_booking_routing?.to_one : "");
            formik.setFieldValue("by_first_carrier", FFAirImpMAWBDetail?.mawb_booking_routing ? FFAirImpMAWBDetail?.mawb_booking_routing?.by_first_carrier : "");
            formik.setFieldValue("to_two", FFAirImpMAWBDetail?.mawb_booking_routing ? FFAirImpMAWBDetail?.mawb_booking_routing?.to_two : "");
            formik.setFieldValue("by_one", FFAirImpMAWBDetail?.mawb_booking_routing ? FFAirImpMAWBDetail?.mawb_booking_routing?.by_one : "");
            formik.setFieldValue("to_three", FFAirImpMAWBDetail?.mawb_booking_routing ? FFAirImpMAWBDetail?.mawb_booking_routing?.to_three : "");
            formik.setFieldValue("by_two", FFAirImpMAWBDetail?.mawb_booking_routing ? FFAirImpMAWBDetail?.mawb_booking_routing?.by_two : "");
            formik.setFieldValue("flight_no_one", FFAirImpMAWBDetail?.mawb_booking_routing ? FFAirImpMAWBDetail?.mawb_booking_routing?.flight_no_one : "");
            formik.setFieldValue("flight_date_one", FFAirImpMAWBDetail?.mawb_booking_routing ? FFAirImpMAWBDetail?.mawb_booking_routing?.flight_date_one : "");
            formik.setFieldValue("flight_no_two", FFAirImpMAWBDetail?.mawb_booking_routing ? FFAirImpMAWBDetail?.mawb_booking_routing?.flight_no_two : "");
            formik.setFieldValue("flight_date_two", FFAirImpMAWBDetail?.mawb_booking_routing ? FFAirImpMAWBDetail?.mawb_booking_routing?.flight_date_two : "");
            formik.setFieldValue("cto", FFAirImpMAWBDetail?.mawb_booking_routing ? FFAirImpMAWBDetail?.mawb_booking_routing?.cto : "");

            formik.setFieldValue("currency", FFAirImpMAWBDetail?.mawb_charge_declaration ? Number(FFAirImpMAWBDetail?.mawb_charge_declaration?.currency) : "");
            formik.setFieldValue("chgs_code", FFAirImpMAWBDetail?.mawb_charge_declaration ? FFAirImpMAWBDetail?.mawb_charge_declaration?.chgs_code : "");
            formik.setFieldValue("wt_val", FFAirImpMAWBDetail?.mawb_charge_declaration ? FFAirImpMAWBDetail?.mawb_charge_declaration?.wt_val : "");
            formik.setFieldValue("other", FFAirImpMAWBDetail?.mawb_charge_declaration ? FFAirImpMAWBDetail?.mawb_charge_declaration?.other : "");
            formik.setFieldValue("declared_value_for_carriage", FFAirImpMAWBDetail?.mawb_charge_declaration ? FFAirImpMAWBDetail?.mawb_charge_declaration?.declared_value_for_carriage : "");
            formik.setFieldValue("declared_value_for_customs", FFAirImpMAWBDetail?.mawb_charge_declaration ? FFAirImpMAWBDetail?.mawb_charge_declaration?.declared_value_for_customs : "");
            formik.setFieldValue("amount_of_insurance", FFAirImpMAWBDetail?.mawb_charge_declaration ? FFAirImpMAWBDetail?.mawb_charge_declaration?.amount_of_insurance : "");

            formik.setFieldValue("weight_charge_prepaid", FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration ? FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration?.weight_charge_prepaid : "");
            formik.setFieldValue("weight_charge_collect", FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration ? FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration?.weight_charge_collect : "");
            formik.setFieldValue("valuation_charge_prepaid", FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration ? FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration?.valuation_charge_prepaid : "");
            formik.setFieldValue("valuation_charge_collect", FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration ? FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration?.valuation_charge_collect : "");
            formik.setFieldValue("tax_prepaid", FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration ? FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration?.tax_prepaid : "");
            formik.setFieldValue("tax_collect", FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration ? FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration?.tax_collect : "");
            formik.setFieldValue("total_due_agent_prepaid", FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration ? FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration?.total_due_agent_prepaid : "");
            formik.setFieldValue("total_due_agent_collect", FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration ? FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration?.total_due_agent_collect : "");
            formik.setFieldValue("total_due_carrier_prepaid", FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration ? FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration?.total_due_carrier_prepaid : "");
            formik.setFieldValue("total_due_carrier_collect", FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration ? FFAirImpMAWBDetail?.mawb_prepaid_charge_declaration?.total_due_carrier_collect : "");
            // formik.setFieldValue("confirm_mawb_generate", FFAirImpMAWBDetail?.confirm_mawb_generate);

            if (FFAirImpMAWBDetail?.hawb_collection) {
                let hawb_collection_arr = [];
                FFAirImpMAWBDetail?.hawb_collection?.map((val) => hawb_collection_arr.push(val.ff_air_import_hawb_id));
                // console.log(hawb_collection_arr);
                formik.setFieldValue("hawb_collection", hawb_collection_arr)
            }

        }

    }, [loadingFFAirImpMAWBDetail, FFAirImpMAWBDetail]);


    useEffect(() => {
        if (token && user_id && formik.values.hawb_collection) {
            if (Array.isArray(formik.values.hawb_collection)) {
                // console.log(formik.values.hawb_collection);
                dispatch(calculateTotalFreightMAWB(token, user_id, formik.values.hawb_collection));
            }
        }
    }, [formik.values.hawb_collection]);


    // useEffect(() => {
    //     if (formik.values.chargeable_wt1 && formik.values.rate_charge1) {
    //         let num1 = Number(formik.values.chargeable_wt1);
    //         let num2 = Number(formik.values.rate_charge1);

    //         if (!isNaN(num1) && !isNaN(num2)) {
    //             formik.setFieldValue("total_freight1", num1 * num2)
    //         } else {
    //             formik.setFieldValue("total_freight1", "");
    //         }
    //     } else {
    //         formik.setFieldValue("total_freight1", "");
    //     }
    // }, [formik.values.chargeable_wt1, formik.values.rate_charge1]);

    // useEffect(() => {
    //     if (formik.values.chargeable_wt2 && formik.values.rate_charge2) {
    //         let num1 = Number(formik.values.chargeable_wt2);
    //         let num2 = Number(formik.values.rate_charge2);

    //         if (!isNaN(num1) && !isNaN(num2)) {
    //             formik.setFieldValue("total_freight2", num1 * num2)
    //         } else {
    //             formik.setFieldValue("total_freight2", "");
    //         }
    //     } else {
    //         formik.setFieldValue("total_freight2", "");
    //     }
    // }, [formik.values.chargeable_wt2, formik.values.rate_charge2]);

    // useEffect(() => {
    //     if (formik.values.chargeable_wt3 && formik.values.rate_charge3) {
    //         let num1 = Number(formik.values.chargeable_wt3);
    //         let num2 = Number(formik.values.rate_charge3);

    //         if (!isNaN(num1) && !isNaN(num2)) {
    //             formik.setFieldValue("total_freight3", num1 * num2)
    //         } else {
    //             formik.setFieldValue("total_freight3", "");
    //         }
    //     } else {
    //         formik.setFieldValue("total_freight3", "");
    //     }
    // }, [formik.values.chargeable_wt3, formik.values.rate_charge3])

    // useEffect(() => {
    //     if (formik.values.chargeable_wt4 && formik.values.rate_charge4) {
    //         let num1 = Number(formik.values.chargeable_wt4);
    //         let num2 = Number(formik.values.rate_charge4);

    //         if (!isNaN(num1) && !isNaN(num2)) {
    //             formik.setFieldValue("total_freight4", num1 * num2)
    //         } else {
    //             formik.setFieldValue("total_freight4", "");
    //         }
    //     } else {
    //         formik.setFieldValue("total_freight4", "");
    //     }
    // }, [formik.values.chargeable_wt4, formik.values.rate_charge4])

    useEffect(() => {
        let num1 = !isNaN(Number(formik.values.weight_charge_prepaid)) ? Number(formik.values.weight_charge_prepaid) : 0;
        let num2 = !isNaN(Number(formik.values.valuation_charge_prepaid)) ? Number(formik.values.valuation_charge_prepaid) : 0;
        let num3 = !isNaN(Number(formik.values.tax_prepaid)) ? Number(formik.values.tax_prepaid) : 0;
        let num4 = !isNaN(Number(formik.values.total_due_agent_prepaid)) ? Number(formik.values.total_due_agent_prepaid) : 0;
        let num5 = !isNaN(Number(formik.values.total_due_carrier_prepaid)) ? Number(formik.values.total_due_carrier_prepaid) : 0;
        formik.setFieldValue("total_prepaid", num1 + num2 + num3 + num4 + num5);
    }, [
        formik.values.weight_charge_prepaid,
        formik.values.valuation_charge_prepaid,
        formik.values.tax_prepaid,
        formik.values.total_due_agent_prepaid,
        formik.values.total_due_carrier_prepaid,
    ]);

    useEffect(() => {
        let num1 = !isNaN(Number(formik.values.weight_charge_collect)) ? Number(formik.values.weight_charge_collect) : 0;
        let num2 = !isNaN(Number(formik.values.valuation_charge_collect)) ? Number(formik.values.valuation_charge_collect) : 0;
        let num3 = !isNaN(Number(formik.values.tax_collect)) ? Number(formik.values.tax_collect) : 0;
        let num4 = !isNaN(Number(formik.values.total_due_agent_collect)) ? Number(formik.values.total_due_agent_collect) : 0;
        let num5 = !isNaN(Number(formik.values.total_due_carrier_collect)) ? Number(formik.values.total_due_carrier_collect) : 0;
        formik.setFieldValue("total_collect", num1 + num2 + num3 + num4 + num5);
    }, [
        formik.values.weight_charge_collect,
        formik.values.valuation_charge_collect,
        formik.values.tax_collect,
        formik.values.total_due_agent_collect,
        formik.values.total_due_carrier_collect,
    ]);


    const handleFormSubmission = (val) => {
        formik.setFieldValue("confirm_mawb_generate", val);
        setModalShow(false);
        formik.handleSubmit();
    }


    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <div className="page-wrapper">
                        <div className="content">
                            <div className="card">
                                <div className="card-body">
                                    <form onSubmit={formik.handleSubmit}>
                                        <div className="row">

                                            <h3 className='mt-2'>MAWB</h3>
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        MAWB No.
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <input
                                                            type="text"
                                                            className='form-control form-control-sm'
                                                            value={FFAirImpMAWBDetail ? FFAirImpMAWBDetail?.mawb_number : "-"}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <h4 className='mt-2'>Party Details</h4>
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Shipper
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={shipperOrganisationOptions}
                                                            styles={customStyles}
                                                            name="shipper_id"
                                                            onChange={option => {
                                                                formik.setFieldValue("shipper_branch_id", "");
                                                                formik.setFieldValue("shipper_branch_bank_account_id", "");
                                                                setShipperBranchOptions([]);
                                                                setShipperBankOptions([]);
                                                                formik.setFieldValue('shipper_id', option.value);
                                                                handleShipperBranch(option.value);
                                                            }}
                                                            value={shipperOrganisationOptions.find(option => option.value === formik.values.shipper_id || null)}
                                                            isLoading={loadingFFAirImpOrganisationList}
                                                            isDisabled={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Shipper Branch
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={shipperBranchOptions}
                                                            styles={customStyles}
                                                            name="shipper_branch_id"
                                                            onChange={option => {
                                                                formik.setFieldValue("shipper_branch_bank_account_id", "");
                                                                setShipperBankOptions([]);
                                                                formik.setFieldValue('shipper_branch_id', option.value);
                                                                handleShipperBanks(option.value);
                                                            }}
                                                            value={shipperBranchOptions.find(option => option.value === formik.values.shipper_branch_id || null)}
                                                            isLoading={loadingFFAirImpShipperBranchList}
                                                        // isDisabled={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Shipper Branch Account No.
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={shipperBankOptions}
                                                            styles={customStyles}
                                                            name="shipper_branch_bank_account_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('shipper_branch_bank_account_id', option.value);
                                                            }}
                                                            value={shipperBankOptions.find(option => option.value === formik.values.shipper_branch_bank_account_id || null)}
                                                            isLoading={loadingFFAirImpConsigneeBranchBankList}
                                                        // isDisabled={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6"></div>
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Consignee
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={consigneeOrganisationOptions}
                                                            styles={customStyles}
                                                            name="quotation_id"
                                                            onChange={option => {
                                                                setConsigneeBranchOptions([]);
                                                                setConsigneeBankOptions([]);
                                                                formik.setFieldValue("consignee_branch_id", "");
                                                                formik.setFieldValue("consignee_branch_bank_account_id", "");
                                                                formik.setFieldValue('consignee_id', option.value);
                                                                handleConsigneeBranch(option.value);
                                                            }}
                                                            value={consigneeOrganisationOptions.find(option => option.value === formik.values.consignee_id || null)}
                                                            isLoading={loadingFFAirImpOrganisationList}
                                                            isDisabled={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Consignee Branch
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={consigneeBranchOptions}
                                                            styles={customStyles}
                                                            name="consignee_branch_id"
                                                            onChange={option => {
                                                                setConsigneeBankOptions([]);
                                                                formik.setFieldValue("consignee_branch_bank_account_id", "");
                                                                formik.setFieldValue('consignee_branch_id', option.value);
                                                                handleConsigneeBanks(option.value);
                                                            }}
                                                            value={consigneeBranchOptions.find(option => option.value === formik.values.consignee_branch_id || null)}
                                                            isLoading={loadingFFAirImpShipperBranchList}
                                                            isDisabled={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Consignee Branch Account No.
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={consigneeBankOptions}
                                                            styles={customStyles}
                                                            name="consignee_branch_bank_account_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('consignee_branch_bank_account_id', option.value);
                                                            }}
                                                            value={consigneeBankOptions.find(option => option.value === formik.values.consignee_branch_bank_account_id || null)}
                                                            isLoading={loadingFFAirImpConsigneeBranchBankList}
                                                        // isDisabled={false}  
                                                        />
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        IATA Agent
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={iataAgentOptions}
                                                            styles={customStyles}
                                                            name="issuing_carrier_agent_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('issuing_carrier_agent_id', option.value);
                                                            }}
                                                            value={iataAgentOptions.find(option => option.value === formik.values.issuing_carrier_agent_id || null)}
                                                        // isLoading={loadingFFAirExpConsigneeBranchBankList}
                                                        // isDisabled={false}  
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="col-md-6"></div> */}

                                            {/* Agent Name */}
                                            {/* <InputTextJSX labelText={"Agent Name"} nameValue={"issuing_carrier_agent_name"} value={formik.values.issuing_carrier_agent_name} onChange={formik.handleChange} maxLength={100} />
                                            <InputTextJSX labelText={"Agent Address"} nameValue={"issuing_carrier_agent_address"} value={formik.values.issuing_carrier_agent_address} onChange={formik.handleChange} />
                                            <InputTextJSX labelText={"Agent IATA Code"} nameValue={"agent_iata_code"} value={formik.values.agent_iata_code} onChange={formik.handleChange} maxLength={10} />
                                            <InputTextJSX labelText={"Agent Account No."} nameValue={"agent_account_number"} value={formik.values.agent_account_number} onChange={formik.handleChange} maxLength={30} /> */}


                                            <h4 className='mt-2'>Flight Booking/ Routing</h4>

                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Airport of Departure
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={airportOptions}
                                                            styles={customStyles}
                                                            name="airport_of_departure_id"
                                                            onChange={(option) => {
                                                                formik.setFieldValue("airport_of_departure_id", option.value)
                                                                formik.setFieldValue("airport_of_departure_name", option.label)
                                                            }}
                                                            value={airportOptions.find(option => option.value === formik.values.airport_of_departure_id || null)}
                                                            isLoading={loadingFFAirImpAirportList}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Airport of Destination
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={airportOptions}
                                                            styles={customStyles}
                                                            name="airport_of_destination_id"
                                                            onChange={(option) => {
                                                                formik.setFieldValue("airport_of_destination_id", option.value)
                                                                formik.setFieldValue("airport_of_destination_name", option.label)
                                                            }}
                                                            value={airportOptions.find(option => option.value === formik.values.airport_of_destination_id || null)}
                                                            isLoading={loadingFFAirImpAirportList}
                                                        />
                                                    </div>
                                                </div>
                                            </div>


                                            <InputTextJSX labelText={"To"} nameValue={"to_one"} value={formik.values.to_one} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                                            <InputTextJSX labelText={"By First Carrier"} nameValue={"by_first_carrier"} value={formik.values.by_first_carrier} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                                            <InputTextJSX labelText={"To"} nameValue={"to_two"} value={formik.values.to_two} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                                            <InputTextJSX labelText={"By"} nameValue={"by_one"} value={formik.values.by_one} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                                            <InputTextJSX labelText={"To"} nameValue={"to_three"} value={formik.values.to_three} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                                            <InputTextJSX labelText={"By"} nameValue={"by_two"} value={formik.values.by_two} onChange={formik.handleChange} splithalf={true} maxLength={30} />

                                            <div className={`col-md-6 mt-2`}>
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        CTO
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <select
                                                            className="form-control form-control-sm"
                                                            id="cto"
                                                            name="cto"
                                                            value={formik.values.cto}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        >
                                                            <option value="" disabled>-Select an option-</option>
                                                            <option value="DCSC">DCSC</option>
                                                            <option value="CELEBI">CELEBI</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <InputTextJSX labelText={"Flt No 1"} nameValue={"flight_no_one"} value={formik.values.flight_no_one} onChange={formik.handleChange} maxLength={15} />
                                            {/* <InputDateJSX labelText={"Flt Dt 1"} nameValue={"flight_date_one"} value={formik.values.flight_date_one} onChange={formik.handleChange} /> */}
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Flt Dt 1
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <input
                                                            type="date"
                                                            className="form-control form-control-sm"
                                                            id={"flight_date_one"}
                                                            name={"flight_date_one"}
                                                            value={formik.values.flight_date_one}
                                                            onChange={formik.handleChange}
                                                            min={new Date().toISOString().split("T")[0]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <InputTextJSX labelText={"Flt No 2"} nameValue={"flight_no_two"} value={formik.values.flight_no_two} onChange={formik.handleChange} maxLength={15} />
                                            {/* <InputDateJSX labelText={"Flt Dt 2"} nameValue={"flight_date_two"} value={formik.values.flight_date_two} onChange={formik.handleChange} /> */}

                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Flt Dt 2
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <input
                                                            type="date"
                                                            className="form-control form-control-sm"
                                                            id={"flight_date_two"}
                                                            name={"flight_date_two"}
                                                            value={formik.values.flight_date_two}
                                                            onChange={formik.handleChange}
                                                            min={new Date().toISOString().split("T")[0]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <h4 className='mt-2'>Charge Declaration</h4>
                                            <SelectReactJSX
                                                labelText={"Currency"}
                                                nameValue={"currency"}
                                                onChange={(option) => { formik.setFieldValue("currency", option.value) }}
                                                options={currencyOptions}
                                                value={currencyOptions.find(option => option.value === formik.values.currency || null)}
                                                isLoading={loadingFFAirImpCurrencyList}
                                            />

                                            <div className={`col-md-6 mt-2`}>
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        CHGS CODE
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <select
                                                            className="form-control form-control-sm"
                                                            id="chgs_code"
                                                            name="chgs_code"
                                                            value={formik.values.chgs_code}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        >
                                                            <option value="" disabled>-Select an option-</option>
                                                            <option value="PP">PP</option>
                                                            <option value="PC">PC</option>
                                                            <option value="CP">CP</option>
                                                            <option value="CC">CC</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={`col-md-6 mt-2`}>
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Wt/Val(P/C)
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <select
                                                            className="form-control form-control-sm"
                                                            id="wt_val"
                                                            name="wt_val"
                                                            value={formik.values.wt_val}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        >
                                                            <option value="" disabled>-Select an option-</option>
                                                            <option value="P">P</option>
                                                            <option value="C">C</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={`col-md-6 mt-2`}>
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Other(P/C)
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <select
                                                            className="form-control form-control-sm"
                                                            id="other"
                                                            name="other"
                                                            value={formik.values.other}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        >
                                                            <option value="" disabled>-Select an option-</option>
                                                            <option value="P">P</option>
                                                            <option value="C">C</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <InputTextJSX labelText={"Declared Value for Carriage"} nameValue={"declared_value_for_carriage"} value={formik.values.declared_value_for_carriage} onChange={formik.handleChange} />
                                            <InputTextJSX labelText={"Declared Value for Customs"} nameValue={"declared_value_for_customs"} value={formik.values.declared_value_for_customs} onChange={formik.handleChange} />
                                            <InputTextJSX labelText={"Amount of Insurance"} nameValue={"amount_of_insurance"} value={formik.values.amount_of_insurance} onChange={formik.handleChange} />
                                            <TextAreaJSX labelText="Handeling Info" nameValue="handling_info" value={formik.values.handling_info} onChange={formik.handleChange} maxLength={430} showWordCount={true} />

                                            <h4 className='mt-2'>Select HAWB No.</h4>
                                            <div className="col-md-12 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        HAWB No.
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={unusedHAWBOptions}
                                                            // styles={customStyles}
                                                            name="shipper_id"
                                                            onChange={selectedOptions => {
                                                                const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                                                formik.setFieldValue("hawb_collection", values);
                                                            }}
                                                            value={unusedHAWBOptions.filter(option =>
                                                                formik.values.hawb_collection.includes(option.value)
                                                            )}
                                                            isLoading={loadingFFAirImpUnusedHAWBUpdateList}
                                                            isDisabled={false}
                                                            isMulti={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <h4 className='mt-2'>Rate Description</h4>
                                            {formik.values.hawb_collection && formik.values.hawb_collection.length ? <div className="table-responsive">
                                                {
                                                    loadingFFAirImpTotalFreight ?
                                                        <div className="center">
                                                            Loading....
                                                        </div> :
                                                        <>
                                                            {FFAirImpTotalFreight && FFAirImpTotalFreight.rate_arr && FFAirImpTotalFreight.rate_arr.map((val, ind) => {
                                                                return <>
                                                                    <div className="row" key={ind + 1}>
                                                                        <div className="col-md-12 d-flex">
                                                                            <label htmlFor="" className='form-label  mb-0 me-2'>
                                                                                HAWB No.
                                                                            </label>
                                                                            <div className="icon-forms mb-3 mb-sm-0">
                                                                                <input
                                                                                    className='form-control form-control-sm'
                                                                                    value={val.hawb_number}
                                                                                    disabled
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <table className="table table-striped table-sm">
                                                                        <thead>
                                                                            <tr>
                                                                                <th scope="col">No.of Pkg*</th>
                                                                                <th scope="col">Gross Wt.*</th>
                                                                                <th scope="col">Chargeable Wt.*</th>
                                                                                {/* <th scope="col">Rate/ Charge*</th> */}
                                                                                <th scope="col">Freight</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                val.rates ?
                                                                                    val.rates.length ?
                                                                                        val.rates.map((v, _i) => {
                                                                                            return <tr>
                                                                                                <td>{v.no_of_pkg}</td>
                                                                                                <td>{v.gross_wt}</td>
                                                                                                <td>{v.chargeable_wt}</td>
                                                                                                <td>{v.total_freight}</td>
                                                                                            </tr>
                                                                                        })
                                                                                        :
                                                                                        <tr>
                                                                                            <td colSpan={4}>No data found.</td>
                                                                                        </tr> :
                                                                                    <tr>
                                                                                        <td colSpan={4}>No data found.</td>
                                                                                    </tr>
                                                                            }

                                                                        </tbody>
                                                                    </table>
                                                                </>
                                                            })}
                                                            <div className="card">
                                                                <div className="card-body">
                                                                    <table className="table table-striped table-sm">
                                                                        <thead>
                                                                            <tr>
                                                                                <th scope="col">Total No.of Pkg*</th>
                                                                                <th scope="col">Total Gross Wt.*</th>
                                                                                <th scope="col">Total Chargeable Wt.*</th>
                                                                                {/* <th scope="col">Rate/ Charge*</th> */}
                                                                                <th scope="col">Total Freight</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>{FFAirImpTotalFreight ? FFAirImpTotalFreight.total_pkg : "-"}</td>
                                                                                <td>{FFAirImpTotalFreight ? FFAirImpTotalFreight.total_gross_wt : "-"}</td>
                                                                                <td>{FFAirImpTotalFreight ? FFAirImpTotalFreight.total_chargable_wt : "-"}</td>
                                                                                <td>{FFAirImpTotalFreight ? FFAirImpTotalFreight.total_freight : "-"}</td>
                                                                            </tr>

                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>

                                                        </>
                                                }

                                            </div>
                                                : null
                                            }

                                            <TextAreaJSX labelText="Nature and Quantity" nameValue="nature_and_qty" value={formik.values.nature_and_qty} onChange={formik.handleChange} maxLength={400} showWordCount={true}/>
                                            <TextAreaJSX labelText="Remarks" nameValue="remarks" value={formik.values.remarks} onChange={formik.handleChange} maxLength={380} showWordCount={true}/>

                                            <h4 className='mt-2'>Prepaid / Collect Charge Declaration</h4>

                                            <div className="table-responsive">
                                                <table className="table table-striped table-sm">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col"></th>
                                                            <th scope="col">Prepaid</th>
                                                            <th scope="col">Collect</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {/* Weight Charge */}
                                                        <tr>
                                                            <td>
                                                                Weight Charge
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className='form-control form-control-sm'
                                                                    name="weight_charge_prepaid"
                                                                    id="weight_charge_prepaid"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.weight_charge_prepaid}
                                                                    maxLength={100}
                                                                    onInput={(event) => {
                                                                        let value = event.target.value;
                                                                        value = value.replace(/[^0-9]/g, '');
                                                                        event.target.value = value;
                                                                    }}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className='form-control form-control-sm'
                                                                    name="weight_charge_collect"
                                                                    id="weight_charge_collect"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.weight_charge_collect}
                                                                    maxLength={100}
                                                                    onInput={(event) => {
                                                                        let value = event.target.value;
                                                                        value = value.replace(/[^0-9]/g, '');
                                                                        event.target.value = value;
                                                                    }}

                                                                />
                                                            </td>
                                                        </tr>
                                                        {/* Valuation Charge */}
                                                        <tr>
                                                            <td>
                                                                Valuation Charge
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className='form-control form-control-sm'
                                                                    name="valuation_charge_prepaid"
                                                                    id="valuation_charge_prepaid"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.valuation_charge_prepaid}
                                                                    maxLength={100}
                                                                    onInput={(event) => {
                                                                        let value = event.target.value;
                                                                        value = value.replace(/[^0-9]/g, '');
                                                                        event.target.value = value;
                                                                    }}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className='form-control form-control-sm'
                                                                    name="valuation_charge_collect"
                                                                    id="valuation_charge_collect"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.valuation_charge_collect}
                                                                    maxLength={100}
                                                                    onInput={(event) => {
                                                                        let value = event.target.value;
                                                                        value = value.replace(/[^0-9]/g, '');
                                                                        event.target.value = value;
                                                                    }}

                                                                />
                                                            </td>
                                                        </tr>
                                                        {/* Tax */}
                                                        <tr>
                                                            <td>
                                                                Tax
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className='form-control form-control-sm'
                                                                    name="tax_prepaid"
                                                                    id="tax_prepaid"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.tax_prepaid}
                                                                    maxLength={100}
                                                                    onInput={(event) => {
                                                                        let value = event.target.value;
                                                                        value = value.replace(/[^0-9]/g, '');
                                                                        event.target.value = value;
                                                                    }}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className='form-control form-control-sm'
                                                                    name="tax_collect"
                                                                    id="tax_collect"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.tax_collect}
                                                                    maxLength={100}
                                                                    onInput={(event) => {
                                                                        let value = event.target.value;
                                                                        value = value.replace(/[^0-9]/g, '');
                                                                        event.target.value = value;
                                                                    }}

                                                                />
                                                            </td>
                                                        </tr>
                                                        {/* Total Due Agent */}
                                                        <tr>
                                                            <td>
                                                                Total Due Agent
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className='form-control form-control-sm'
                                                                    name="total_due_agent_prepaid"
                                                                    id="total_due_agent_prepaid"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.total_due_agent_prepaid}
                                                                    maxLength={100}
                                                                    onInput={(event) => {
                                                                        let value = event.target.value;
                                                                        value = value.replace(/[^0-9]/g, '');
                                                                        event.target.value = value;
                                                                    }}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className='form-control form-control-sm'
                                                                    name="total_due_agent_collect"
                                                                    id="total_due_agent_collect"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.total_due_agent_collect}
                                                                    maxLength={100}
                                                                    onInput={(event) => {
                                                                        let value = event.target.value;
                                                                        value = value.replace(/[^0-9]/g, '');
                                                                        event.target.value = value;
                                                                    }}

                                                                />
                                                            </td>
                                                        </tr>
                                                        {/* Total Due Carrier */}
                                                        <tr>
                                                            <td>
                                                                Total Due Carrier
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className='form-control form-control-sm'
                                                                    name="total_due_carrier_prepaid"
                                                                    id="total_due_carrier_prepaid"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.total_due_carrier_prepaid}
                                                                    maxLength={100}
                                                                    onInput={(event) => {
                                                                        let value = event.target.value;
                                                                        value = value.replace(/[^0-9]/g, '');
                                                                        event.target.value = value;
                                                                    }}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className='form-control form-control-sm'
                                                                    name="total_due_carrier_collect"
                                                                    id="total_due_carrier_collect"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.total_due_carrier_collect}
                                                                    maxLength={100}
                                                                    onInput={(event) => {
                                                                        let value = event.target.value;
                                                                        value = value.replace(/[^0-9]/g, '');
                                                                        event.target.value = value;
                                                                    }}

                                                                />
                                                            </td>
                                                        </tr>
                                                        {/* Total  */}
                                                        <tr>
                                                            <td>
                                                                Total
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className='form-control form-control-sm'
                                                                    name="total_prepaid"
                                                                    id="total_prepaid"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.total_prepaid}
                                                                    maxLength={100}
                                                                    disabled
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className='form-control form-control-sm'
                                                                    name="total_collect"
                                                                    id="total_collect"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.total_collect}
                                                                    maxLength={100}
                                                                    disabled
                                                                />
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                            <InputDateJSX labelText="Airway Bill Date" nameValue="airwaybill_date" value={formik.values.airwaybill_date} onChange={formik.handleChange} minToday={true} />
                                            <InputDateJSX labelText="Clearance/Exec.Dt" nameValue="clearance_Exec_date" value={formik.values.clearance_Exec_date} onChange={formik.handleChange} minToday={true} />
                                            <InputDateJSX labelText="CSR Date" nameValue="CSR_date" value={formik.values.CSR_date} onChange={formik.handleChange} minToday={true} />
                                            <InputDateJSX labelText="Executed At" nameValue="executed_at" value={formik.values.executed_at} onChange={formik.handleChange} minToday={true} />




                                        </div>
                                        <div className="row d-flex justify-content-end mt-2">
                                            <div className="col-md-6 d-flex justify-content-end">
                                                {/* <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Add"}
                                        </button> */}
                                                <button type="button" className="btn btn-sm btn-danger" disabled={disableSubmit} onClick={() => setModalShow(true)}>
                                                    {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                                                </button>
                                            </div>
                                        </div>



                                        <Modal
                                            show={modalShow}
                                            onHide={() => setModalShow(false)}
                                            // size="sm"
                                            aria-labelledby="contained-modal-title-vcenter"
                                            centered
                                        >
                                            <Modal.Header closeButton>
                                                <Modal.Title id="contained-modal-title-vcenter">
                                                    Do you want to Generate MAWB No. ?
                                                </Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <div className="d-flex justify-content-around">
                                                    <button className="btn btn-primary btn-sm" type='submit' onClick={() => { handleFormSubmission("Yes") }} style={{ width: "30%" }}>
                                                        Yes
                                                    </button>
                                                    <button className="btn btn-outline-primary btn-sm" type='submit' onClick={() => { handleFormSubmission("No") }} style={{ width: "30%" }}>
                                                        No
                                                    </button>
                                                </div>
                                            </Modal.Body>
                                        </Modal>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
            }

        </>
    )
}

export default ConsoleShipmentMAWBEditAI